// DS: i3.36
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const LastPage: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.099 7C16.099 6.44772 16.5138 6 17.0256 6C17.5374 6 17.9523 6.44772 17.9523 7V17C17.9523 17.5523 17.5374 18 17.0256 18C16.5138 18 16.099 17.5523 16.099 17L16.099 7Z" />
        <path d="M12.2136 11.2426L7.62684 6.29289C7.26496 5.90237 6.67823 5.90237 6.31635 6.29289C5.95446 6.68342 5.95446 7.31658 6.31635 7.70711L10.2473 11.949L6.31635 16.1924C5.95446 16.5829 5.95446 17.2161 6.31635 17.6066C6.67823 17.9971 7.26496 17.9971 7.62684 17.6066L12.2136 12.6569C12.5755 12.2663 12.5755 11.6332 12.2136 11.2426Z" />
      </svg>
    </IconWrap>
  );
};
LastPage.displayName = 'LastPage';

export default LastPage;
